import zh1 from './zh1'
export default {
  route: {
    platmanagemtnt: '平台管理',    
    branchlist: '分店清单',
    fabriclist: '面料商家',
    myaccount:'资金账户',
    designers: '入驻版师清单',
    '客户取货方式': '客户取货方式',
    '邮寄': '邮寄',
    '收货地址': '收货地址',
    '顺丰ID': '顺丰ID',
    '物流信息': '物流信息',
    '物流公司': '物流公司',
    '发货': '发货',
    '收货人': '收货人',
    '收货人电话': '收货人电话',
    '联系方式': '联系方式',
    '售后订单': '售后订单',
    '预售订单': '预售订单',
    '详情': '详情',
    '处理': '处理',
    '待接收订单': '待接收订单',
    '已接收订单': '已接收订单',
    '手动派单': '手动派单',
    '平台版师': '平台版师',
    '入驻版师': '入驻版师',
    '支付时间': '支付时间',
    '商品退款': '商品退款',
    '邮寄费用': '邮寄费用',
    '退邮寄费': '退邮寄费',
    '券减免': '券减免',
    '售后事项': '售后事项',
    '退款商品': '退款商品',
    '货物状态': '货物状态',
    '退款原因': '退款原因',
    '退款金额': '退款金额',
    '相关图片': '相关图片',
    '同意退款': '同意退款',
    '拒绝退款': '拒绝退款',
    '签收货物': '签收货物',
    '确认签收': '确认签收',
    '确认退款': '确认退款',
    '确定要作废这个订单吗': '确定要作废这个订单吗',
    '视频安装': '视频安装',
    '安装时间': '安装时间',
    '安装人': '安装人',
    '安装状态': '安装状态',
    '安装备注': '安装备注',
    '请选择安装时间': '请选择安装时间',
    '请选择安装人': '请选择安装人',
    '请选择安装状态': '请选择安装状态',
    '课程退款': '课程退款',
    '课程名称': '课程名称',
    '支付并开通': '支付并开通',
    '修改价格': '修改价格',
    '原始订单金额': '原始订单金额',
    '新订单金额': '新订单金额',
    '已开通': '已开通',
    '已提交': '已提交',
    '已支付': '已支付',
    '已作废': '已作废',
    '刷新': '刷新',
    '当前没有未派送的订单': '当前没有未派送的订单',
    '成衣图片': '成衣图片',
    '客户体型': '客户体型',
    '暂无客户体型图片': '暂无客户体型图片',
    '饰品信息': '饰品信息',
    '抢单': '抢单',
    '自动匹配': '自动匹配',
    '撤销更改': '撤销更改',
    '保存量体尺码': '保存量体尺码',
    '正在下载文件中请稍后': '正在下载文件中，请稍后……',
    '加载中': '加载中……',
    '下载当前客户版型': '下载当前客户版型',
    '下载团体客户版型': '下载团体客户版型',
    '产品标题': '产品标题',
    '下载': '下载',
    '成衣型号': '成衣型号',
    '售后状态': '售后状态',
    '订单状态': '订单状态',
    '退款发起日期': '退款发起日期',
    '货运信息': '货运信息',
    '面料号': '面料号',
    '饰品号': '饰品号',
    '我的订单': '我的订单',
    '专属版型': '专属版型',
    '新增订单': '新增订单',
    '纸质版型': '纸质版型',
    '线下量体': '线下量体',
    '下载团体客户数据': '下载团体客户数据',
    '面料订单': '面料订单',
    '辅料订单': '辅料订单',
    '账户支付': '账户支付',
    '已取件': '已取件',
    '运输中': '运输中',
    '已签收': '已签收',
    '已发货': '已发货',
    '待发货': '待发货',
    '多状态': '多状态',
    '运单号': '运单号',
    '送至': '送至',
    '设置顺丰ID': '设置顺丰ID',
    '请录入顺丰ID': '请录入顺丰ID',
    '邮费': '邮费',
    '打印费': '打印费',
    '退打印费': '退打印费',
    '已完成打印': '完成打印',
    '已打印': '已打印',
    '打印': '打印',
    '订单已发货': '订单已发货！',
    '版型已打印': '版型已打印！',
    '未收到货': '未收到货',
    '已收到货': '已收到货',
    '不想要了': '不想要了',
    '协商一致退款': '协商一致退款',
    '空包裹': '空包裹',
    '快递一直未送到': '快递一直未送到',
    '商品破损已拒签': '商品破损已拒签',
    '客户申请退货退款': '客户申请退货退款',
    '买家退货': '买家退货',
    '退款完毕': '退款完毕',
    '客户寄回货物': '客户寄回货物',
    '商家同意退货': '商家同意退货',
    '等待接收退货说明': '等待接收客户退回的货物，收到货后确认签收即可完成退款。',
    '商家拒绝退货': '商家拒绝退货',
    '拒绝原因': '拒绝原因',
    '回复时间': '回复时间',
    '商家已退款': '商家已退款',
    '退款成功时间': '退款成功时间',
    '请录入拒绝原因': '请录入拒绝原因',
    '确认签收并退款': '确认签收并退款',
    '确认签收提示': '您确认收到退回货物了吗，点击确认后将向客户退回货款',
    '确认退款提示': '当前订单未发货，将退回总金额',
    '您确认退款吗': '您确认退款吗？',
    '收件人': '收件人：',
    '收件人电话': '收件人电话：',
    '收件地址': '收件地址：',
    '物流信息标签': '物流信息：',
    '原订单号': '原订单号：',
    '商品货号': '商品货号：',
    '退款失败': '退款失败',
    '全部门店': '全部门店',
    '自营平台': '自营平台',
    '重置': '重置',
    '批次号': '批次号',
    '量体类型': '量体类型',
    '下载个人': '下载个人',
    '下载团体': '下载团体',
    '打印清单': '打印清单',
    '收件人标签': '收件人',
    '联系电话标签': '联系电话',
    '收件地址标签': '收件地址',
    '购买版型': '购买版型',
    '购买尺码标签': '购买尺码',
    '微信扫码查看小程序': '微信扫码查看小程序',
    '微信扫码联系客服': '微信扫码联系客服',
    '微信扫码查看细节': '微信扫码查看细节',
    '面料生产提示': '因不同属性面料料性差别大，为保证成品效果，请选择相似\\相近面料生产成衣。',
    // 2026-10-12：A4打印使用独立长提示，商品详情提示保持原样。
    'A4纸样打印提示': '温馨提示：因各类服装面料物理特性差异较大，建议买家选用材质相近的面料制作成衣。不同制版设计师对款式与结构的理解存在个体偏差，本纸样仅体现本店版型原始设计效果。客户收到纸样后：请务必先打样试穿、确认版型符合自身需求方可裁剪面料；若未试样直接下料，由此引发的面料损耗、成品瑕疵等全部损失与责任均由客户自行承担。【提供来图制版服务，联系客服或致电：4001609268 转 3】',
    '电话标签': '电话',
    '网址': '网址',
    '总接单': '总接单:',
    '今接单': '今接单:',
    '总': '总',
    '今': '今',
    '请选择需要回复的信息': '请选择需要回复的信息',
    '输入消息内容': '输入消息内容',
    '请输入金额': '请输入金额',
    '发送': '发送',
    '出价': '出价',
    '咨询': '咨询',
    '企微': '企微',
    '结束': '结束',
    '是否继续': '当前操作会关闭当前售后订单，是否继续？',
    '是': '是',
    '否': '否',
    '订单已确认等待付款': '订单已确认，等待客户付款。',
    '订单已付款等待发布': '订单已付款，等待版师发布版型。',
    '请选择待派送订单': '请选择待派送订单！',
    '请输入物流单号': '请输入物流单号',
    '定制图片': '定制图片',
    '定制尺码': '定制尺码',
    '上传附件': '上传附件',
    '请将BOKE文件打包上传': '请将BOKE文件+尺码文件+PLT文件打包上传',
    '购买版型按钮': '购买版型',
    '线下预约量体': '线下预约量体',
    '面料商': '面料商',
    '金额': '金额',
    '公司': '公司',
    '生产商': '生产商',
    '成衣生产商': '成衣生产厂家',
    '成衣生产厂家': '成衣生产厂家',
    '输入生产商': '输入生产商',
    '总接单数': '总接单数:',
    '今日接单': '今日接单:',
    '待发货标签': '待发货',
    '到店自取': '到店自取',
    '物流': '物流：',
    '单号': '单号：',
    '查看详情': '查看详情',
    '接收订单': '接收订单',
    '确定要撤回这个订单吗': '确定要撤回这个订单吗？',
    '撤回': '撤回',
    '加工费/生产商': '加工费/生产商',
    '订单来源': '订单来源',
    '订单信息': '订单信息',
    '版型类型': '版型类型',
    '价格': '价格',
    '总金额': '总金额',
    '名称': '名称',
    '在线下载': '在线下载',
    '相同地址合并发货': '相同地址合并发货',
    '联系地址': '联系地址',
    '点击查看详情': '点击查看详情',
    '点击上传版型': '点击上传版型',
    '点击删除已上传的版型文件': '点击删除已上传的版型文件',
    '点击下载订单文件': '点击下载订单文件',
    '已退款': '已退款',
    '版型费': '版型费',
    '纸质版型订单': '纸质版型订单',
    '快递商': '快递商',
    '打印清单提示': '打印清单',
    '请输入需要下载的内容': '正在下载文件中，请稍后……',
    '开通成功提示': '开通成功，请通知会员退出重新登录后生效',
    '请选择需要开通的会员订单': '请选择需要开通的会员订单',
    '该订单已支付不能修改': '该订单已支付，不能修改',
    '修改成功': '修改成功',
    '订单已分配提示': '订单已分配生产商，无需重复分配',
    '您已成功接单': '您已成功接单',
    '订单未付款不能发货': '订单未付款，不能发货',
    '订单已退款不能发货': '订单已退款，不能发货',
    '订单已作废不能发货': '订单已作废，不能发货',
    '请填写物流信息': '请填写物流信息',
    '订单已发货提示': '订单已发货',
    '正在下载文件中': '正在下载文件中，请稍后……',
    '售后退款': '售后退款',
    '退回': '退回',
    '生产商统一提供': '生产商统一提供',
    '请输入生产商': '输入生产商',
    '客户姓名手机号订单号': '客户姓名/手机号/订单号',
    '智能量体订单': '智能量体订单',
    '匹配范围': '匹配范围',
    '运费': '运费',
    '成衣预售订单': '成衣预售订单',
    '缺少收件人信息': '缺少收件人信息',
    '订单作废成功': '订单作废成功！',
    '请选择是否同意退款': '请选择是否同意退款！',
    '售后退款标签': '售后退款',
    '后台退款备注': '后台退款，备注：',
    '成衣现货订单': '成衣现货订单',
    '高震服装设计': '高震服装设计',
    '分店': '分店',
    '饰品退款': '饰品退款',
    '邮寄费': '邮寄费',
    '设计师': '设计师',
    '接单时间': '接单时间',
    '发起时间': '发起时间',
    '服务时间': '服务时间',
    '加码订单号': '加码订单号',
    '点击复制': '点击复制',
    '点击下载': '点击下载',
    '未打印': '未打印',
    '回复内容不能为空': '回复内容不能为空！',
    '没有发现售后订单': '没有发现售后订单',
    '派单成功': '派单成功！',
    '该机构当日接单数量已超限': '该机构当日接单数量已超限，不能再接单了。',
    '账号已停用或绑定错误': '账号已停用或绑定错误。',
    '请设置发货人信息': '请设置发货人信息',
    '上传成功': '上传成功',
    '的订单已发货': '的订单已发货！',
    '饰品订单': '饰品订单',
    '量体定制订单': '量体定制订单',
    '输入': '输入',
    '自动匹配，匹配范围：': '自动匹配，匹配范围：',
    '已退款标签': '已退款',
    '退款商品:': '退款商品:',
    '货物状态:': '货物状态:',
    '退款原因:': '退款原因:',
    '退款金额:': '退款金额:',
    '退款说明:': '退款说明:',
    '相关图片:': '相关图片:',
    '会员开通支付订单': '会员开通支付订单',
    '支付金额': '支付金额',
    '操作人': '操作人',
    '订单时间': '订单时间',
    '操作时间': '操作时间',
    '订单类别': '订单类别',
    '优惠金额': '优惠金额',
    '客户名称': '客户名称',
    '升级级别': '升级级别',
    '级别周期': '级别周期',
    '级别结束时间': '级别结束时间',
    '可下载次数': '可下载次数',
    '平台金额': '平台金额',
    '待向平台支付并开通会员': '待向平台支付并开通会员',
    '价格修改记录': '价格修改记录',
    '修改人': '修改人',
    '修改时间': '修改时间',
    '会员下单': '会员下单',
    '会员升级充值订单': '会员升级订单',
    '会员升级订单': '会员升级订单',
    '级别开始时间': '级别开始时间',
    ...zh1
  },
  
  
}
